// "Confira seu e-mail": a shortcut to the merchant's webmail, only for the
// providers we can recognise by the address. Gmail opens already searched
// for the Korza sender (spam included); Outlook on the web has no documented
// search deep link, so it opens the inbox.

export type WebmailProvider = 'gmail' | 'outlook';

export interface Webmail {
  provider: WebmailProvider;
  url: string;
}

const GMAIL_DOMAINS = new Set(['gmail.com', 'googlemail.com']);
const OUTLOOK_DOMAINS = new Set([
  'outlook.com',
  'outlook.com.br',
  'hotmail.com',
  'hotmail.com.br',
  'live.com',
  'msn.com',
]);

/** Any Korza sender (no-reply's exact address is a backend env var). */
const GMAIL_SEARCH = 'from:korza.app in:anywhere newer_than:1d';

export function webmailFor(email: string): Webmail | null {
  const domain = email.trim().toLowerCase().split('@')[1];
  if (!domain) return null;
  if (GMAIL_DOMAINS.has(domain)) {
    return {
      provider: 'gmail',
      url: `https://mail.google.com/mail/u/0/#search/${encodeURIComponent(GMAIL_SEARCH)}`,
    };
  }
  if (OUTLOOK_DOMAINS.has(domain)) {
    return { provider: 'outlook', url: 'https://outlook.live.com/mail/0/' };
  }
  return null;
}
